const phoneNumberInput = document.querySelector("#user_phone_number");
const initialCountry = document.querySelector("#phoneNumber").dataset.internationalCountryCode

var intlValid = window.intlTelInput(phoneNumberInput, {
  utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
  separateDialCode: true,
  initialCountry: initialCountry,
  preferredCountries: ["us", "ie", "gb"]
});

$('form#new_user').submit(function(e) {
  if (intlValid.isValidNumber()) {
    var formattedNumber = intlValid.getNumber()
    phoneNumberInput.value = formattedNumber;
    $('#phoneNumberAlert').hide();
    return true;
  } else {
    phoneNumberInput.focus()
    $('#phoneNumberAlert').show();
    return false;
  }
});
